<template>
  <v-container fluid>
    <v-row class="justify-center">
      <v-col cols="12" sm="10">
        <v-data-table
          hide-default-footer
          flat
          :mobile-breakpoint="200"
          :headers="headers"
          :items="Assets"
        >
          <template v-slot:top>
            <v-toolbar flat dense color="primary darken-2  white--text">
              <v-toolbar-title>Assets</v-toolbar-title>
              <v-spacer></v-spacer>

              <div>
                <cashDisplay
                  small
                  colorName="white"
                  Textcolor="white--text"
                  :isloading="searching"
                  :Balance="ReturnTotalArray(Assets)"
                ></cashDisplay>
              </div>
            </v-toolbar>
            <v-divider></v-divider>
          </template>

          <template v-slot:item.Amount="{ item }">
            {{ item && item.Amount && item.Amount.toLocaleString() }}
            {{ item.AmountType | MoneySigns }}
          </template>
        </v-data-table>
      </v-col>

      <v-col cols="12" sm="8" md="5">
        <v-data-table
          hide-default-footer
          flat
          :mobile-breakpoint="200"
          :headers="LiabHeader"
          :items="Liabilities"
        >
          <template v-slot:top>
            <v-toolbar flat dense color="error darken-2 white--text">
              <v-toolbar-title>Liabilities</v-toolbar-title>
              <v-spacer></v-spacer>

              <div>
                <cashDisplay
                  small
                  colorName="white"
                  Textcolor="white--text"
                  :isloading="searching"
                  :Balance="ReturnTotalArray(Liabilities)"
                ></cashDisplay>
              </div>
            </v-toolbar>
            <v-divider></v-divider>
          </template>

          <template v-slot:[`item.Amount`]="{ item }">
            {{ item && item.Amount && Math.abs(item.Amount).toLocaleString() }}
            {{ item.AmountType | MoneySigns }}
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" sm="8" md="5">
        <v-data-table
          hide-default-footer
          flat
          :mobile-breakpoint="200"
          :headers="CapitalHeader"
          :items="Capital"
        >
          <template v-slot:top>
            <v-toolbar flat dense color="teal darken-2 white--text">
              <v-toolbar-title>Capital</v-toolbar-title>
              <v-spacer></v-spacer>

              <div>
                <cashDisplay
                  small
                  colorName="white"
                  Textcolor="white--text"
                  :isloading="searching"
                  :Balance="ReturnTotalArray(Capital)"
                ></cashDisplay>
              </div>
            </v-toolbar>
            <v-divider></v-divider>
          </template>

          <template v-slot:[`item.Amount`]="{ item }">
            {{ item && item.Amount && item.Amount.toLocaleString() }}
            {{ item.AmountType | MoneySigns }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
// import axios from "axios";
export default {
  components: {
    cashDisplay: () => import("@/components/coman/cashView"),
    // searchDate: () => import("@/components/util/searchDate.vue")
  },
  data() {
    return {
      SalesRepo: "/Reports/statement/balancesheet",
      searching: false,
      isloading: false,
      hideFooter: false,
      search: "",
      fromDate: "",
      toDate: "",
      Assets: [],
      Capital: [],
      Liabilities: [],
      TotalBalance: [],
      headers: [
        {
          text: "Account",
          value: "AccountName",
          class: "primary darken-2 white--text",
        },

        {
          text: "Amount",
          value: "Amount",
          class: "primary darken-2 white--text",
        },
      ],
      CapitalHeader: [
        {
          text: "Account",
          value: "AccountName",
          class: "teal darken-2 white--text",
        },

        { text: "Amount", value: "Amount", class: "teal darken-2 white--text" },
      ],
      LiabHeader: [
        {
          text: "Account",
          value: "AccountName",
          class: "error darken-2 white--text",
        },

        {
          text: "Amount",
          value: "Amount",
          class: "error darken-2 white--text",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["UsersToken"]),
  },
  methods: {
    ReturnTotalArray(ArrayTran = []) {
      if (!ArrayTran.length) return [];
      let total = ArrayTran.reduce((result, item) => {
        let { Amount } = result[item.AmountType] || { Amount: 0 };
        result[item.AmountType] = {
          Amount: Amount + item.Amount,
          AccountName: item.AmountType,
        };
        return result;
      }, {});
      return Object.keys(total).map(key => total[key]);
    },
    GetReq(url) {
      if (!url) url = this.SalesRepo;

      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query: {},
      });
    },
    loadSales() {
      try {
        this.searching = true;
        this.isloading = true;

        this.GetReq()
          .then(value => {
            this.searching = false;
            this.isloading = false;
            // console.log(value.data);
            this.Assets = value.data["Assets"] || [];
            let Revenue = (value.data["Revenue"] || []).reduce(
              (total, cash) => {
                return (total += cash.Amount);
              },
              0
            );
            let netIncom = (value.data["Expenses"] || []).reduce(
              (total, cash) => {
                return (total -= cash.Amount);
              },
              Revenue
            );

            // console.log(netIncom);

            this.Capital = [
              ...(value.data["Capital"] || []),
              {
                AccountName: "Net Income",
                Amount: netIncom,
                AmountType: this.UsersToken.CashBase,
              },
            ];
            this.Capital = this.Capital.filter(cap => cap.Amount != 0);
            this.Liabilities = value.data["Liabilities"] || [];
            this.Liabilities = [
              ...this.Liabilities,
              ...this.Assets.filter(item => item.Amount < 0).map(item => ({
                ...item,
                Amount: Math.abs(item.Amount),
              })),
            ];
            this.Assets = this.Assets.filter(item => item.Amount > 0);
          })
          .catch(err => {
            this.searching = false;
            this.isloading = false;
            console.log(err);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.loadSales();
  },
};
</script>
